import { render, staticRenderFns } from "./index.vue?vue&type=template&id=599032dd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=599032dd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599032dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('599032dd')) {
      api.createRecord('599032dd', component.options)
    } else {
      api.reload('599032dd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=599032dd&scoped=true", function () {
      api.rerender('599032dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/linkaddress/index.vue"
export default component.exports